














































































































































import Vue from 'vue';
import { SpinnerState } from '@/enums/spinnerState';
import { MessageType } from '@/enums/messageType';
import { dialogueMessageService } from '@/services/dialogueMessageService';
import { TextField } from '@/types/forms/fields/textField';
import { toolsRepository } from '@/api';
import { authService } from '@/services/authService';
import { InstallerData } from '@/api/interfaces/tools/installerData';
import SpinnerArea from '@/components/molecules/spinnerArea/SpinnerArea.vue';
import FormField from '@/components/molecules/formField/FormField.vue';
import FormInputText from '@/components/atoms/formInputText/FormInputText.vue';
import AppButton from '@/components/atoms/appButton/AppButton.vue';
import FormTextBlock from '@/components/molecules/formTextBlock/FormTextBlock.vue';

export default Vue.extend({
    name: 'ToolInstallerData',
    components: {
        SpinnerArea,
        FormField,
        FormInputText,
        AppButton,
        FormTextBlock,
    },
    data: () => {
        return {
            spinner: SpinnerState.off,
            installerData: null as InstallerData | null,
            databaseName: '',
            overrideInstallerIdModel: { value: '' } as TextField,
            overrideCidaasSubModel: { value: '' } as TextField,
            overrideResultMessage: '',
        };
    },
    computed: {
        formattedJson(): string {
            return this.installerData
                ? JSON.stringify(this.installerData, null, 2)
                : '';
        },
        companyCount(): number {
            return this.installerData?.unternehmen?.length ?? 0;
        },
        companiesWithMultipleInstallersIds(): string[] {
            return (
                this.installerData?.unternehmen
                    ?.filter(
                        (company) => (company.installateure?.length ?? 0) > 1,
                    )
                    .map((company) => company.id) ?? []
            );
        },
        companiesWithSingleInstallerIds(): string[] {
            return (
                this.installerData?.unternehmen
                    ?.filter(
                        (company) => (company.installateure?.length ?? 0) === 1,
                    )
                    .map((company) => company.id) ?? []
            );
        },
        installerEntryCount(): number {
            return (
                this.installerData?.unternehmen?.reduce(
                    (sum, company) =>
                        sum + (company.installateure?.length ?? 0),
                    0,
                ) ?? 0
            );
        },
        uniqueInstallerCount(): number {
            return this.uniqueInstallerIds.size;
        },
        installersInMultipleCompaniesCount(): number {
            return this.installersInMultipleCompaniesIds.length;
        },
        installersInMultipleCompaniesIds(): string[] {
            const ids: string[] = [];
            this.companyIdsByInstallerId.forEach((companyIds, installerId) => {
                if (companyIds.size > 1) {
                    ids.push(installerId);
                }
            });
            return ids;
        },
        uniqueInstallersWithCidaasSubCount(): number {
            const ids = new Set<string>();
            this.installerData?.unternehmen?.forEach((company) => {
                company.installateure?.forEach((installer) => {
                    if (installer.id && installer.cidaasSub) {
                        ids.add(installer.id);
                    }
                });
            });
            return ids.size;
        },
        uniqueInstallerIds(): Set<string> {
            const ids = new Set<string>();
            this.installerData?.unternehmen?.forEach((company) => {
                company.installateure?.forEach((installer) => {
                    if (installer.id) {
                        ids.add(installer.id);
                    }
                });
            });
            return ids;
        },
        companyIdsByInstallerId(): Map<string, Set<string>> {
            const map = new Map<string, Set<string>>();
            this.installerData?.unternehmen?.forEach((company) => {
                company.installateure?.forEach((installer) => {
                    if (!installer.id) {
                        return;
                    }
                    if (!map.has(installer.id)) {
                        map.set(installer.id, new Set<string>());
                    }
                    map.get(installer.id)?.add(company.id);
                });
            });
            return map;
        },
    },
    created() {
        if (this.$route.query.code === 'unauthorized') {
            dialogueMessageService.show('unauthorized', MessageType.error);
        }
    },
    async mounted() {
        this.spinner = SpinnerState.opaque;
        this.overrideCidaasSubModel.value = authService.sub ?? '';
        await this.loadInstallerData();
        this.spinner = SpinnerState.off;
    },
    methods: {
        async loadInstallerData(): Promise<void> {
            const response = await toolsRepository.getInstallers();
            this.databaseName = response.database;
            this.installerData = response.data
                ? (JSON.parse(response.data) as InstallerData)
                : null;
        },
        async overrideCidaasSub(): Promise<void> {
            this.overrideResultMessage = '';
            const installerId = this.overrideInstallerIdModel.value?.trim();
            if (!installerId) {
                this.overrideResultMessage = 'Please enter an installer id.';
                return;
            }

            this.spinner = SpinnerState.transparent;
            const response = await toolsRepository.overrideInstallerCidaasSub(
                installerId,
                this.overrideCidaasSubModel.value ?? '',
            );
            await this.loadInstallerData();
            this.spinner = SpinnerState.off;

            this.overrideResultMessage = `Updated ${response.updated} installer entry/entries with id "${installerId}".`;
        },
    },
});
